/** @format */

export const userStates = {
  isProcessing: "Checking",
};
